// @flow

import type {Company, Language, RiskRating, CompaniesSortOption, CompaniesSortBy} from '@/types'
import NoAvailableTableData from '@/elements/no-available-table-data'
import {getReportLinkDetailsForGA} from '@/views/util'

import React from 'react'

import Flag from '@/elements/flag'
import {hideScoreForCountries} from '@/defaults'

type Props = {
  companies: Array<Company>,
  countryCode: string,
  currSortOptions: CompaniesSortOption,
  shownRiskRating: RiskRating,
  l: Language,
  showCompanyReport: (string) => void,
  sortBy: (string) => void,
}

const isScoreHidden = (companyCountryCode: string) => {
  return hideScoreForCountries.indexOf(companyCountryCode) > -1
}

const getClassNameForSortBy = (props: Props) => (column: CompaniesSortBy) => {
  let classNames = ['sort-by']
  const {sortBy, sortDir} = props.currSortOptions
  if (sortBy === column) {
    if (sortDir === 'asc') {
      classNames.push('drop-up')
    } else {
      classNames.push('drop-down')
    }
  }
  return classNames.join(' ')
}

const renderRating = ({ratingLocal, ratingCommon}, l) => {
  const band = ratingCommon.trim()
  if (isNaN(ratingLocal)) {
    return <span>{l(ratingLocal)}</span>
  }
  return <span><span className={`rating-band badge-${band}`}>{band}</span>&nbsp;{ratingLocal}</span>
}

const renderRows = (props: Props) => (companies: Array<Company>) => {
  return (
    companies.map((company) =>
      <tr key={company.safeNumber}>
        <td width='25%'>{company.safeNumber}</td>
        <td width='15%'><Flag code={company.countryCode}/>&nbsp;&nbsp;{company.countryCode}</td>
        <td width='40%'>
          <a data-click_through={getReportLinkDetailsForGA(props.countryCode, company.safeNumber)}
            onClick={() => props.showCompanyReport(company.safeNumber)}
          >
            {company.name}
          </a>
        </td>
        <td width='20%'>{!isScoreHidden(company.countryCode) ? renderRating(company, props.l) : false}</td>
      </tr>
    )
  )
}

export const RawList = (props: Props) =>
  <div className="monitoring-table-ctr">
    <table className={props.companies.length > 10 ? 'table table-condensed shrink' : 'table table-condensed'}>
      <thead>
        <tr className={props.companies.length === 0 ? 'disabled-header' : ''}>
          <th width='25%'><a onClick={() => props.companies.length > 0 ? props.sortBy('companyId') : null}>{props.l('Safe number')}<span className={getClassNameForSortBy(props)('companyId')}></span></a></th>
          <th width='15%'><a onClick={() => props.companies.length > 0 ? props.sortBy('countryCode') : null}>{props.l('Country')}<span className={getClassNameForSortBy(props)('countryCode')}></span></a></th>
          <th width='40%'><a onClick={() => props.companies.length > 0 ? props.sortBy('companyName') : null}>{props.l('Company name')}<span className={getClassNameForSortBy(props)('companyName')}></span></a></th>
          <th width='20%'><a onClick={() => props.companies.length > 0 ? props.sortBy('localScore') : null}>{props.l('Score')}<span className={getClassNameForSortBy(props)('localScore')}></span></a></th>
        </tr>
      </thead>
    </table>
    <div className="tbody-scroll">
      <table className="table table-condensed">
        <tbody>
          { props.companies.length > 0
            ? renderRows(props)(props.companies)
            : <NoAvailableTableData numOfCols={4} text={props.l('No companies found')}/>}
        </tbody>
      </table>
    </div>
  </div>

export default RawList



// WEBPACK FOOTER //
// ./src/views/analysis-page/companies/list.js